/**
 * Page tour of « Planning stream configuration » (route `planning/stream-config`, legacy screen):
 * add a stream, choose what it shows, copy its public address, save, and the live preview once a
 * stream is saved. Anchors live in PlanningTVConfiguration/index.jsx; the config box exists only once
 * a stream exists and the preview once the selected stream is saved (both steps drop out otherwise).
 */
export const PLANNING_STREAM_TOUR = {
    id: 'planning-stream',
    version: 1,
    paths: ['planning/stream-config'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Planning on a screen',
            description: 'Show the planning on a TV on the day of the event: who is up now and who comes next.',
        },
        {
            key: 'add',
            target: '[data-tour="stream-head"]',
            placement: 'bottom',
            title: 'Add a screen',
            description: 'Create one stream per screen. Each one shows the workout and the wave you choose.',
        },
        {
            key: 'config',
            target: '[data-tour="stream-config"]',
            placement: 'right',
            placementNarrow: 'bottom',
            title: 'What the screen shows',
            description: 'Four choices, top to bottom.',
            entries: [
                { label: 'The stream', text: 'which screen you are setting up.' },
                { label: 'The workout', text: 'the workout whose waves are displayed.' },
                { label: 'The wave', text: 'the wave shown first; the screen then follows the planning.' },
                { label: 'Global rank', text: 'tick it to show the overall ranking next to the lanes.' },
            ],
        },
        {
            key: 'link',
            target: '[data-tour="stream-link"]',
            placement: 'bottom',
            title: 'The screen’s address',
            description: 'Open this address on the TV or the computer connected to it. It updates by itself.',
        },
        {
            key: 'actions',
            target: '[data-tour="stream-actions"]',
            placement: 'top',
            title: 'Save the stream',
            description: 'Save once the workout and the wave are chosen. Delete removes this screen for good.',
        },
        {
            key: 'preview',
            target: '[data-tour="stream-preview"]',
            placement: 'top',
            title: 'What the TV shows',
            description: 'A live preview of the saved stream, exactly as it appears on the screen.',
        },
    ],
}

export default PLANNING_STREAM_TOUR
